import React, { useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

import makeStyles from '@mui/styles/makeStyles';

import ValidIcon from '@mui/icons-material/Check';
import InvalidIcon from '@mui/icons-material/Clear';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';


import ResetIcon from '@mui/icons-material/Cancel';
import CheckIcon from '@mui/icons-material/PlayCircleFilled';

import withLoader from 'components/Shared/withLoader';
import { green, red } from '@mui/material/colors';
const TextFieldWithLoader = withLoader(TextField);

const useStyles = makeStyles((theme) => ({
    reset: {
        color: red[500],
    },
    check: {
        color: green[500],
    },
    adornment: {
        marginTop: '0px',
    },
}));


function ArticleGestionImportArea({ onImport }) {

    const classes = useStyles();

    const [value, setValue] = useState('');

    const [articles, setArticles] = useState([]);
    
    const [nokReferences, setNokReferences] = useState([]);

    const [loading, setLoading] = useState(false);
    

    const fetchData = async (references) => {

        if (references.length > 0) {

            setLoading(true);

            await axios.post(`api/articles-gestion/check`, { references: references })
                .then(function (response) {

                    let articles = response.data;

                    let okArticles = articles.filter(article => article.designation);

                    let noKReferences = articles.filter(article => !article.designation).map(article => article.reference);

                    setArticles(okArticles);
                    setNokReferences(noKReferences);


                })
                .catch(function (error) {
                    console.log(error);
                })
                .then(function () {
                    setLoading(false);
                    setValue('');
                });
        }
    };


    const handleClickValid = () => {

        console.log("handleClickValid value", value);

        let references = value
            .replace(/\D/gm, " ")
            .replace(/\s+/gm, " ")
            .trim()
            .split(' ')
            .map(ref => ref.padStart(6, '0'));

        fetchData(references);

    };

    

    return (
        <div style={{ width: '100%'}}>


            {(loading || (articles.length === 0 && nokReferences.length === 0)) && (
                <TextFieldWithLoader
                    isLoading={loading}
                    label={"Articles"}
                    multiline
                    style={{ width: '100%' }}
                    aria-label="minimum height"
                    variant="filled"
                    InputLabelProps={{ shrink: true }}
                    placeholder="Veuillez 'coller' votre liste de références :
                    321321
                    112112
                    457845
                    …"
                    onChange={e => setValue(e.target.value)}
                    value={value}
                    InputProps={{
                        endAdornment: value && (
                            <InputAdornment className={classes.adornment}>

                                <IconButton onClick={() => setValue('')} className={classes.reset} size="large"><ResetIcon /></IconButton>
                                <IconButton onClick={handleClickValid} className={classes.check} size="large"><CheckIcon /></IconButton>

                            </InputAdornment>),
                    }}
                />
            )}




            {!loading && (articles.length > 0 || nokReferences.length > 0) && (

                <React.Fragment>
                    {articles.map((article, index) => {
                        return (<p key={index}><ValidIcon style={{ color: green[500] }}/> {article.reference} - {article.designation}</p>) })}

                    {nokReferences.map((nokReference, index) => { return (<p key={index}><InvalidIcon style={{ color: red[500] }}/> {nokReference}</p>) })}



                    <Button onClick={() => { setValue(''); setArticles([]); setNokReferences([]);}}>Annuler</Button>
                    <Button disabled={articles.length === 0} onClick={() => { onImport(articles); setValue(''); setArticles([]); setNokReferences([]); }}>Ajouter</Button>

                </React.Fragment>
                
            )}


        </div>
    );




}

ArticleGestionImportArea.propTypes = {
    onImport: PropTypes.func.isRequired,
};

ArticleGestionImportArea.defaultProps = {
}


export default ArticleGestionImportArea;